var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#232226",
    d: "M20.206 15.973v3.402a.96.96 0 0 1-.895.96q-.63.045-1.03.045c-8.502 0-15.394-6.892-15.394-15.395q0-.4.044-1.03a.96.96 0 0 1 .96-.894h3.402a.48.48 0 0 1 .48.433q.033.33.061.53a13.4 13.4 0 0 0 1.163 3.85.44.44 0 0 1-.142.546L6.78 9.904a12.55 12.55 0 0 0 6.585 6.585l1.481-2.073a.445.445 0 0 1 .552-.143c1.217.578 2.515.969 3.849 1.16q.2.029.529.06a.48.48 0 0 1 .432.48z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .174h23.092v23.092H0z"
  })))));
};
export default SvgPhone;